import {
  anyPass, equals, isEmpty, isNil,
} from 'ramda';

export default anyPass([isNil, isEmpty, equals('*')]);
